export const locale = {
  lang: "de",
  data: {
    BILLDATE: "Rechnungsdatum",
    COSTS: "Kosten",
  },
};
